import type { Options } from "../../types/options";
import type { ExtendedExtract } from "types/extendedExtract";

type EventId = string;
type Key = ExtendedExtract<
  Options["featureName"],
  | "[テスト以外には使わない] eventIdが引数にある時の テストの featureName"
  | "newEventTicketPage"
  | "vspoExclusive"
  | "multiAngle"
>;
type FeatureNameEventIdMapType = {
  [K in Key]: EventId[];
};

// featureName に依存するハードコーディングを Options の増減に合わせて対応するため、型で縛る
// 特に feature flag から機能除却時の削除漏れ対策
const FEATURE_NAME_EVENT_ID_MAP_BASE: FeatureNameEventIdMapType = {
  "[テスト以外には使わない] eventIdが引数にある時の テストの featureName": [
    "test-event-id",
  ],
  newEventTicketPage: [
    // dev環境
    "evt_OTSdn5k3Y4izkU6NH7PR",
    "evt_woAGzIkFpUXI1ZbayfoA",
    // テスト環境
    "evt_K82fmFaXLeY1fFOmHw9r",
    // vspo
    "evt_ZdlNpSceJPswQKdIikOE",
  ],
  vspoExclusive: [
    // vspo
    "evt_ZdlNpSceJPswQKdIikOE",
    // テスト環境
    "evt_K82fmFaXLeY1fFOmHw9r",
  ],
  multiAngle: [
    // vspo
    "evt_ZdlNpSceJPswQKdIikOE",
    // テスト環境
    "evt_K82fmFaXLeY1fFOmHw9r",
  ],
};

// featureName の増減に合わせて処理を変更させないため、 Record<string, string[]> に upcast しておく
const FEATURE_NAME_EVENT_ID_MAP = Object.fromEntries<EventId[]>(
  Object.entries(FEATURE_NAME_EVENT_ID_MAP_BASE)
);

export const isAllowedByEventId = (
  eventId: EventId,
  featureName: string
): boolean => {
  const allowedEventIds = FEATURE_NAME_EVENT_ID_MAP[featureName];
  if (allowedEventIds === undefined) return false;
  return allowedEventIds.includes(eventId);
};
